import { useState } from "react";
import React from "react";
import "./Header.css";
import About from "../about/About";
import Experience from "../experience/Experience";
import Portfolio from "../portfolio/Portfolio";
import Testimonials from "../testimonial/Testimonial"
import Contact from "../contact/Contact"

export default function Header() {
    const [isOpen, setIsOpen] = useState(false);
    const [activeComponent, setActiveComponent] = useState(false);

    function openSideBar(componentId) {
        if(isOpen===false) {
            document.querySelector("body").style.overflow="hidden";
            document.querySelector("body").style.maxHeight="100vh";
            console.log("Test")
        } else {
            document.querySelector("body").style.overflow="auto";
            document.querySelector("body").style.maxHeight="auto";
        }

        setIsOpen(isOpen ? false : true);
        setActiveComponent(componentId);
    }

    return (
        <>
            <header>
                <div className="navbar-wrapper">
                    <span id="hamburger" onClick={openSideBar} class="material-symbols-outlined">
                        menu
                    </span>

                    <div className="header-logo">
                        <img src="/logo/logo-only-full.png" alt="" />
                    </div>

                    <div className="header-nav">
                        <a href="#about"> About </a>
                        <a href="#experience"> Experience </a>
                        <a href="#portfolio"> Portfolio </a>
                        <a href="#testimonials"> Testimonials </a>
                        <a href="#contact"> Contact </a>
                    </div>
                </div>

                <div className="sidebar" style={{ display: isOpen? "flex" : "none "}}>
                    <div className="sidebar-top">
                        <div className="sidebar-item">
                            <span class="material-symbols-outlined"> person </span>
                            <a href="#about" onClick={() => openSideBar("about")}> About </a>
                        </div>

                        <div className="sidebar-item">
                            <span class="material-symbols-outlined"> work_history </span>
                            <a href="#experience" onClick={() => openSideBar("experience")}> Experience </a>
                        </div>

                        <div className="sidebar-item">
                            <span class="material-symbols-outlined"> task </span>
                            <a href="#portfolio" onClick={() => openSideBar("portfolio")}> Portfolio </a>
                        </div>

                        <div className="sidebar-item">
                            <span class="material-symbols-outlined"> groups </span>
                            <a href="#testimonials" onClick={() => openSideBar("testimonials")}> Testimonials </a>
                        </div>

                        <div className="sidebar-item">
                            <span class="material-symbols-outlined"> mail </span>
                            <a href="#contact" onClick={() => openSideBar("contact")}> Contact </a>
                        </div>
                    </div>

                    <div className="sidebar-bottom">
                        <p> © 2023 Owen Marscel </p>
                    </div>
                </div>
            </header>

        </>
    );
}
